import { defineMessages } from 'react-intl';

export const i18n: {
	externalLinkIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearFilters: {
		id: string;
		defaultMessage: string;
	};
} = defineMessages({
	externalLinkIconLabel: {
		id: 'inline-product-filters.external-link-icon.label',
		defaultMessage: 'External Link Icon',
		description:
			'Accessible label for an external link icon shown next to filter options in the Quick Find inline product filters, indicating the link navigates away from the current page.',
	},
	moreButtonLabel: {
		id: 'inline-product-filters.more-filters.label',
		defaultMessage: 'More',
		description: 'Label to convey that there are more filters to choose from',
	},
	filterByIcon: {
		id: 'quick-find-filters.filter-by-icon-label',
		defaultMessage: 'Filter by Icon',
		description:
			'Accessible label for the filter icon button in the Quick Find inline product filters bar, used to indicate the purpose of the icon to screen readers.',
	},
	moreButtonTooltip: {
		id: 'inline-product-filters.more-filters.tooltip',
		defaultMessage: 'Open a full page search with more filter options for {product}',
		description:
			'Tooltip shown on the "More" button in the Quick Find inline product filters bar when hovered. The placeholder {product} will be substituted with the product name (e.g. "Jira").',
	},
	clearFilters: {
		id: 'quick-find.filters.clear-filters-button-label',
		defaultMessage: 'Clear filters',
	},
});
